import createReducer from '../../../../../../../helpers/createReducer';
import { updateOrderedItemsReportSearchQuery } from '../../../../../actions/reports/ordered-items';

const initialState = {
  requestTime: [],
  trackingMethodId: [],
  reservationStatus: [],
  groupBy: []
};

const updateOrderedItemsReportSearchQueryHandler = action => ({
  [action.toString()]: (_, { payload: searchQuery }) => searchQuery
});

export default createReducer(initialState, {
  ...updateOrderedItemsReportSearchQueryHandler(
    updateOrderedItemsReportSearchQuery
  )
});
